import {useCallback, useState} from 'react';
import {useEventProcessor} from 'shared/events/useEventProcessor';
import {useHandleEmptyRooms} from 'components/customer/Job/helpers/useHandleEmptyRooms';
import {useJobPDFVerification} from 'components/customer/Job/helpers/useJobPDFVerification';
import {useRecessRailsValidation} from 'components/customer/Job/helpers/useRecessRailsValidation';
import {useRequestedDeliveryDateHandler} from 'shared/helpers/useRequestedDeliveryDateHandler';
import {useSubmitJob} from 'components/customer/Job/helpers/useSubmitJob';
import {useQFPproductPrompt} from 'components/customer/Job/helpers/useQFPProductPrompt';
import {useGoToJobConfirmationPage} from 'components/customer/Job/helpers/useGoToCheckout';
import {useGoToPaymentPage} from 'components/customer/Job/helpers/useGoToPayment';
import {useNotificationContext} from 'contexts/NotificationContext';
import {genericMessageHandler} from 'shared/helpers';
import {useConfirmVariation} from 'components/customer/Job/helpers/useConfirmVariation';

export const useJobSubmitHandler = () => {
    const {notify} = useNotificationContext();
    const [loader, setLoader] = useState(false);

    const events = [
        useConfirmVariation(),
        useGoToJobConfirmationPage(), // navigate customer to job confirmation page
        useQFPproductPrompt(),
        useRequestedDeliveryDateHandler(),
        useRecessRailsValidation(),
        useHandleEmptyRooms(),
        useJobPDFVerification(),
        useGoToPaymentPage(), // navigate customer to payment page
        useSubmitJob(),
    ];

    const {processEvents} = useEventProcessor(events);

    const handleJobSubmission = useCallback(
        async (event: React.MouseEvent) => {
            setLoader(true);
            try {
                await processEvents(event);
            } catch (error) {
                // let google analytics know that an error occurred
                // and what it is.
                // eslint-disable-next-line no-console -- reade above comment
                console.error('Job submission error: ', error);
                genericMessageHandler(notify, {
                    message:
                        'An error occurred while submitting the job please try again later.',
                });
            } finally {
                setLoader(false);
            }
        },
        [processEvents]
    );

    return {
        loader,
        handleJobSubmission,
    };
};
